const fmt  = n => "$" + Math.round(n ?? 0).toLocaleString("es-CL");
const pct  = n => (n ?? 0).toFixed(1) + "%";
const clr  = v => v >= 70 ? "#1D9E75" : v >= 50 ? "#EF9F27" : "#E24B4A";

export default function ResumenGeneral({ resumen }) {
  if (!resumen) return null;

  const pedidos = [
    { label: "Total pedidos",    value: resumen.total_pedidos ?? 0,    color: "#111",    desc: "registrados" },
    { label: "Por confirmar",    value: resumen.total_pendientes ?? 0,  color: "#EF9F27", desc: "esperando confirmación" },
    { label: "En curso",         value: resumen.total_en_transito ?? 0, color: "#534AB7", desc: "en tránsito" },
    { label: "Entregados",       value: resumen.total_entregados ?? 0,  color: "#1D9E75", desc: "entrega exitosa" },
    { label: "Cancelados",       value: resumen.total_cancelados ?? 0,  color: "#888",    desc: "no confirmados" },
    { label: "Devueltos",        value: resumen.total_fallidos ?? 0,    color: "#E24B4A", desc: "devolución / rechazo" },
  ];

  const tasas = [
    { label: "Tasa de confirmación", value: resumen.tasa_confirmacion ?? 0, desc: "Confirmados / Total pedidos" },
    { label: "Tasa de entrega",      value: resumen.tasa_entrega ?? 0,      desc: "Entregados / Confirmados" },
    { label: "Tasa de devolución",   value: resumen.tasa_devolucion ?? 0,   desc: "Devueltos / Confirmados", inverso: true },
    { label: "Tasa de cancelación",  value: resumen.tasa_cancelacion ?? 0,  desc: "Cancelados / Total pedidos", inverso: true },
    { label: "Pedidos pendientes",   value: resumen.tasa_pendientes ?? 0,   desc: "Pendientes / Total pedidos", inverso: true },
  ];

  // Barra de composición de pedidos
  const total = resumen.total_pedidos || 1;
  const barras = [
    { key: "entregados",  v: resumen.total_entregados ?? 0,  color: "#1D9E75" },
    { key: "en_transito", v: resumen.total_en_transito ?? 0, color: "#534AB7" },
    { key: "pendientes",  v: resumen.total_pendientes ?? 0,  color: "#EF9F27" },
    { key: "cancelados",  v: resumen.total_cancelados ?? 0,  color: "#aaa" },
    { key: "fallidos",    v: resumen.total_fallidos ?? 0,    color: "#E24B4A" },
  ];

  return (
    <div>
      {/* ── KPIs financieros ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 9, marginBottom: "1.25rem" }}>
        {[
          { label: "Retiros del mes",  value: fmt(resumen.total_retiros),          sub: "Ganancias retiradas",     accent: "#1D9E75" },
          { label: "Margen potencial", value: fmt(resumen.margen_potencial_total),  sub: "Incl. en tránsito",       accent: "#534AB7" },
          { label: "Gasto Meta Ads",   value: fmt(resumen.gasto_meta_total),        sub: "Inversión publicitaria",  accent: "#E24B4A" },
        ].map(k => (
          <div key={k.label} style={{ background: "#f7f7f5", borderRadius: 10, padding: "14px 16px", borderTop: `3px solid ${k.accent}` }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>{k.label}</div>
            <div style={{ fontSize: 24, fontWeight: 600, color: k.accent }}>{k.value}</div>
            <div style={{ fontSize: 11, color: "#aaa", marginTop: 3 }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* ── Categoría 1: Ventas ── */}
      <div style={{ background: "#fff", border: "0.5px solid #e8e8e6", borderRadius: 12, padding: "1.1rem 1.25rem", marginBottom: "1rem" }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "1rem" }}>
          Categoría 1 · Ventas
        </div>

        <div style={{ background: "#fafaf9", borderRadius: 10, padding: "14px 18px", marginBottom: "1rem", borderLeft: "4px solid #111" }}>
          <div style={{ fontSize: 11, color: "#aaa", marginBottom: 4 }}>Ventas teóricas — todos los pedidos desde Shopify</div>
          <div style={{ fontSize: 32, fontWeight: 700, color: "#111" }}>{fmt(resumen.ventas_teoricas)}</div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginBottom: "1.25rem" }}>
          {[
            { label: "Ventas reales",   value: resumen.ventas_reales   ?? 0, color: "#1D9E75", desc: "Entregados",               pct: resumen.ventas_teoricas ? resumen.ventas_reales   / resumen.ventas_teoricas * 100 : 0 },
            { label: "Ventas en curso", value: resumen.ventas_en_curso ?? 0, color: "#534AB7", desc: "En tránsito + por confirmar", pct: resumen.ventas_teoricas ? resumen.ventas_en_curso / resumen.ventas_teoricas * 100 : 0 },
            { label: "Ventas perdidas", value: resumen.ventas_perdidas ?? 0, color: "#E24B4A", desc: "Fallidos + cancelados",      pct: resumen.ventas_teoricas ? resumen.ventas_perdidas / resumen.ventas_teoricas * 100 : 0 },
          ].map(k => (
            <div key={k.label} style={{ background: "#fafaf9", borderRadius: 10, padding: "13px 15px", borderBottom: `3px solid ${k.color}` }}>
              <div style={{ fontSize: 10, color: "#aaa", marginBottom: 4 }}>{k.label}</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: k.color }}>{fmt(k.value)}</div>
              <div style={{ height: 3, borderRadius: 2, background: "#eee", marginTop: 8, marginBottom: 5 }}>
                <div style={{ height: 3, borderRadius: 2, background: k.color, width: `${Math.min(k.pct, 100)}%` }} />
              </div>
              <div style={{ fontSize: 10, color: "#bbb" }}>{k.pct.toFixed(1)}% · {k.desc}</div>
            </div>
          ))}
        </div>

        {/* Subcategoría 2: Ingresos */}
        <div style={{ borderTop: "0.5px solid #f0f0ee", paddingTop: "1rem" }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "0.75rem" }}>
            Categoría 2 · Ingresos (billetera Dropi)
          </div>
          <div style={{ background: "#fafaf9", borderRadius: 10, padding: "12px 18px", marginBottom: "0.85rem", borderLeft: "4px solid #111" }}>
            <div style={{ fontSize: 11, color: "#aaa", marginBottom: 3 }}>Ingresos teóricos — reales + en curso + perdidos</div>
            <div style={{ fontSize: 26, fontWeight: 700, color: "#111" }}>{fmt(resumen.ingresos_teoricos)}</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
            {[
              { label: "Ingresos reales",   value: resumen.ingresos_reales   ?? 0, color: "#1D9E75", desc: "ENTRADAS billetera — entregados",        pct: resumen.ingresos_teoricos ? resumen.ingresos_reales   / resumen.ingresos_teoricos * 100 : 0 },
              { label: "Ingresos en curso", value: resumen.ingresos_en_curso ?? 0, color: "#534AB7", desc: "Proyección tasa entrega × en tránsito",   pct: resumen.ingresos_teoricos ? resumen.ingresos_en_curso / resumen.ingresos_teoricos * 100 : 0 },
              { label: "Ingresos perdidos", value: resumen.ingresos_perdidos ?? 0, color: "#E24B4A", desc: "Ingreso no cobrado por pedidos fallidos",  pct: resumen.ingresos_teoricos ? resumen.ingresos_perdidos / resumen.ingresos_teoricos * 100 : 0 },
            ].map(k => (
              <div key={k.label} style={{ background: "#fafaf9", borderRadius: 10, padding: "12px 14px", borderBottom: `3px solid ${k.color}` }}>
                <div style={{ fontSize: 10, color: "#aaa", marginBottom: 4 }}>{k.label}</div>
                <div style={{ fontSize: 20, fontWeight: 600, color: k.color }}>{fmt(k.value)}</div>
                <div style={{ height: 3, borderRadius: 2, background: "#eee", marginTop: 8, marginBottom: 5 }}>
                  <div style={{ height: 3, borderRadius: 2, background: k.color, width: `${Math.min(k.pct, 100)}%` }} />
                </div>
                <div style={{ fontSize: 10, color: "#bbb" }}>{k.pct.toFixed(1)}% · {k.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Categoría 3: Información de Pedidos ── */}
      <div style={{ background: "#fff", border: "0.5px solid #e8e8e6", borderRadius: 12, padding: "1.1rem 1.25rem", marginBottom: "1rem" }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "1rem" }}>
          Categoría 3 · Información de Pedidos
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 10, marginBottom: "1.25rem" }}>
          {pedidos.map(k => (
            <div key={k.label} style={{ background: "#fafaf9", borderRadius: 10, padding: "12px 14px", borderBottom: `3px solid ${k.color}` }}>
              <div style={{ fontSize: 10, color: "#aaa", marginBottom: 4 }}>{k.label}</div>
              <div style={{ fontSize: 26, fontWeight: 700, color: k.color, lineHeight: 1 }}>{k.value.toLocaleString("es-CL")}</div>
              <div style={{ fontSize: 10, color: "#bbb", marginTop: 4 }}>{k.desc}</div>
            </div>
          ))}
        </div>

        {/* Barra de composición */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: "flex", height: 10, borderRadius: 6, overflow: "hidden", gap: 1 }}>
            {barras.filter(b => b.v > 0).map(b => (
              <div key={b.key} style={{ width: `${(b.v / total) * 100}%`, background: b.color }} />
            ))}
          </div>
          <div style={{ display: "flex", gap: 14, marginTop: 7, flexWrap: "wrap" }}>
            {[
              { label: "Entregados",  color: "#1D9E75" },
              { label: "En tránsito", color: "#534AB7" },
              { label: "Pendientes",  color: "#EF9F27" },
              { label: "Cancelados",  color: "#aaa" },
              { label: "Devueltos",   color: "#E24B4A" },
            ].map(l => (
              <span key={l.label} style={{ fontSize: 10, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ width: 8, height: 8, borderRadius: 2, background: l.color, display: "inline-block" }} />
                {l.label}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* ── Categoría 4: Tasas ── */}
      <div style={{ background: "#fff", border: "0.5px solid #e8e8e6", borderRadius: 12, padding: "1.1rem 1.25rem" }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "1rem" }}>
          Categoría 4 · Indicadores de Tasa
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
          {tasas.map(t => {
            const v = t.value;
            const color = t.inverso
              ? (v <= 10 ? "#1D9E75" : v <= 25 ? "#EF9F27" : "#E24B4A")
              : clr(v);
            return (
              <div key={t.label} style={{ background: "#fafaf9", borderRadius: 10, padding: "14px 16px" }}>
                <div style={{ fontSize: 10, color: "#aaa", marginBottom: 6 }}>{t.label}</div>
                <div style={{ fontSize: 28, fontWeight: 700, color, lineHeight: 1 }}>{pct(v)}</div>
                {/* Barra de progreso */}
                <div style={{ height: 4, borderRadius: 3, background: "#eee", marginTop: 10, marginBottom: 6 }}>
                  <div style={{ height: 4, borderRadius: 3, background: color, width: `${Math.min(v, 100)}%`, transition: "width 0.4s" }} />
                </div>
                <div style={{ fontSize: 10, color: "#bbb" }}>{t.desc}</div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
}
